/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseReportConfigurationForAssessmentAgent extends models.ReportConfigurationForAiAgent {
    constructor() {
        super();
        this.setDiscriminator("BaseReportConfigurationForAssessmentAgent");
    }

    getFixupPrototypeFunction() { return BaseReportConfigurationForAssessmentAgent.fixupPrototype; }

    static newInstance(model: Partial<BaseReportConfigurationForAssessmentAgent>): BaseReportConfigurationForAssessmentAgent {
        let obj = Object.assign(new BaseReportConfigurationForAssessmentAgent(), model);
        BaseReportConfigurationForAssessmentAgent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseReportConfigurationForAssessmentAgent>): BaseReportConfigurationForAssessmentAgent {
        if (!model) return null;
        return BaseReportConfigurationForAssessmentAgent.newInstance(<BaseReportConfigurationForAssessmentAgent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseReportConfigurationForAssessmentAgent) {
        if (!obj) return;

        models.BaseReportConfigurationForAssessmentAgent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseReportConfigurationForAssessmentAgent): boolean {
        if (models.ReportConfigurationForAiAgent.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseReportConfigurationForAssessmentAgent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of the Tenant.
     */
    tenant_id: string;

}
